export default __webpack_public_path__ + "static/media/STADTBRANCHENBUCH.bab89f1d.png";